export const sanitizeGtmId = (value: unknown): string | null => {
  // Only strings are allowed
  if (typeof value !== "string") return null;

  // Trim whitespace and normalize to uppercase
  const v = value.trim().toUpperCase();

  // Strict allow-list: only "GTM-" followed by A–Z and 0–9
  if (!/^GTM-[A-Z0-9]+$/.test(v)) return null;

  // Optional sanity limit
  if (v.length > 50) return null;

  return v;
};
